export default "__VITE_ASSET__BWAooCBo__"